import PageHero from "@/components/site/PageHero";
import Reveal from "@/components/site/Reveal";
import { EXHIBITION_IMAGES, PARTNERSHIPS } from "@/data/content";
import { useT } from "@/i18n";

export default function ProjectsPartnerships() {
  const t = useT();
  // Combine translated text with original images
  const items = t.pages.concepts.items.map((it, i) => ({
    ...it,
    image: PARTNERSHIPS[i]?.image,
  }));

  return (
    <div data-testid="projects-page" className="bg-white">
      <PageHero
        eyebrow={t.pages.concepts.eyebrow}
        title={t.pages.concepts.title}
        subtitle={t.pages.concepts.subtitle}
        image={EXHIBITION_IMAGES[4]}
      />

      <section className="py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14 space-y-28 lg:space-y-40">
          {items.map((p, i) => {
            const reverse = i % 2 === 1;
            return (
              <Reveal
                key={p.title}
                className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center ${
                  reverse ? "lg:[&>*:first-child]:order-2" : ""
                }`}
              >
                <div className="lg:col-span-7">
                  <div className="relative aspect-[4/3] overflow-hidden bg-black/5 group">
                    <img
                      src={p.image}
                      alt={p.title}
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1600ms] ease-out group-hover:scale-105"
                    />
                  </div>
                </div>
                <div className="lg:col-span-5">
                  <p className="eyebrow">{p.subtitle}</p>
                  <h3 className="heading-display mt-4 text-4xl sm:text-5xl lg:text-6xl uppercase">
                    {p.title}
                  </h3>
                  <p className="mt-6 text-base lg:text-lg text-black/75 leading-relaxed">
                    {p.body}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>
    </div>
  );
}
